/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: SaveIndicator.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/4 @ 1517
 * ---
 * Description:
 */

import { Intent, Spinner } from '@blueprintjs/core';
import React               from 'react';
import { Editor }          from '../../../store/observables/Editor';
import { observer }        from 'mobx-react';

interface SaveIndicatorProps {
  editor: Editor;
}

export const SaveIndicator = observer((props: SaveIndicatorProps) => {
  return (
    <div>
      { props.editor.saveFeature.isSaving &&
        <span>
          <Spinner
            className="inline-block"
            intent={ Intent.PRIMARY }
            size={ 15 }
          />
          <span className="mt-0.5 pt-0.5"> Salvo...</span>
        </span>
      }
      {
        !props.editor.saveFeature.isSaving &&
        <span>Salvataggio periodico automatico</span>
      }
    </div>
  );
});
